import React, {Component}        from 'react';
import {connect}              from 'react-redux';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import $ from 'jquery';
import {BrowserRouter as Router,
        Route,
        Redirect}             from 'react-router-dom';
import HomeConteudo           from '../home/home';
import Tripulacao             from '../comunicacao/tripulacao/tripulacao';
import Equipes                from '../comunicacao/equipe/equipes';
import Equipe                 from '../comunicacao/equipe/equipe';
import Missao                 from '../missao/missao';
import Batalha                from '../batalha/batalha';
import BatalhaJogo            from '../batalha/jogo/batalhar_jogo';
import MissaoConcluir         from '../missao/missao_concluir';
import MissaoRecompensa       from '../missao/missao_recompensa';
import Desafios               from '../desafios/desafios';
import DesafiosJogos          from '../desafios/desafios_aluno_jogos';
import Menu                   from '../menu/menu';
import Topo                   from '../topo/topo';
import Footer                 from '../footer/footer';
import FooterHome             from '../home/footer_home';
import bg_tripulacao          from "../../../img/bg/bg_tripulacao.png";
import {SetStatusTalentos}    from '../../../actions/notificacaoAction';
import Talentos               from '../talentos/talentos';
import Perfil                 from '../perfil/perfil';
import Loader                 from '../loader/loader';

import '../../../css/aluno/bootstrap-grid.css';
import '../../../css/aluno/core.css';
import '../../../css/aluno/hud.css';
import '../../../css/aluno/action.css';
import "../../../css/aluno/quest.css";
import "../../../css/aluno/pagination.css";
import "../../../css/aluno/colors.css";
import "../../../css/aluno/hack.css";


class HomeAluno extends Component {

    constructor(props) {
        super(props);

        this.state = {
            load: false
        }
    }    

    ajust(){
		var wh = $('.hud').height();
		wh -= $(".hud-bottom").outerHeight(true);
		wh -= $(".hud-top").outerHeight(true);
	    $("main").css('height',wh+"px").parent().toggleClass("active",true);
	}

    componentDidMount() {   
      
        setTimeout(function () {
            this.setState({load: true});
        }.bind(this), 10);
    }

    render() {
   
        if (!this.props.isAuthenticated) {
            return (<Redirect to='/login'/>);
        }
        const localurl = window.location.pathname.split("/");
        if (localurl.length === 3 && localurl[2] === "home" || localurl[2] === "home" && localurl[3] === ""  ) {
            var renderFooter = <FooterHome/>;
           $('body').addClass('custom');
        }else{
            var renderFooter =  <Footer/>;
            $('body').removeClass('custom');
        }

        // this.ajust();
		// $(window).resize(this.ajust);

        const bg = (this.props.actionBg ? this.props.actionBg : bg_tripulacao);

        // (this.props.session.perfil === this.props.config.userAluno
        //     ? "container_master"
        //     : "container_master_professor");

        const bgHtml = document.getElementsByClassName("gamefica")[0];
        bgHtml.setAttribute("style", `background-image:url(${bg})`);
// return(<Loader/>);


const RouterPag =   <Router basename={this.props.menu.raiz}>
<section className="hud">
    <Topo />
    <div className="hud-middle">
        <aside className="hud-middle-aside">
            <nav className="menu">
                <Menu lado="esquerdo" />
            </nav>
        </aside>
        <Route path={this.props.menu.home} component={HomeConteudo} exact/>
        <Route path={this.props.menu.comunicacao.tripulacao} component={Tripulacao} />
        <Route path={this.props.menu.comunicacao.equipes} component={Equipes} />
        <Route path={`${this.props.menu.comunicacao.equipe}/:id`} component={Equipe} />
        <Route path={this.props.menu.missao.home} component={Missao} />
        <Route path={this.props.menu.batalha.aluno.home} component={Batalha} />
        <Route path={`${this.props.menu.batalha.aluno.jogo}/:id`} component={BatalhaJogo} />
        <Route path={`${this.props.menu.missao.concluir}/:id`} component={MissaoConcluir} />
        <Route path={`${this.props.menu.missao.recompensa}/:id`} component={MissaoRecompensa} />     
        <Route path={this.props.menu.talentos.home} component={Talentos} />
        <Route path={this.props.menu.desafios.home} component={Desafios} />
        <Route path={`${this.props.menu.desafios.jogos}/:ati_id/:ati_tipo`} component={DesafiosJogos} />
        <Route path={this.props.menu.perfil.home} component={Perfil}/>
        <aside className="hud-middle-aside">
            <nav className="menu">
                <Menu style="right" lado="direito" />
            </nav>
        </aside>
    </div>
    {renderFooter}
</section>
</Router>;

const a =<Loader/>;


// return (<div> {!this.state.load  ? <Loader/>: RouterPag} </div>);
return (<div>{ RouterPag}</div>);
    }
}

function mapStateToProps(state){
    return {
            isAuthenticated: state.auth.isAuthenticated, 
            session: state.auth.session, 
            menu: state.configReducer.menu, 
            config: state.configReducer.config,
            actionBg: state.scopoReducer.actionBg,
            checkSelect : state.scopoReducer.checkSelect
           };
}

export default connect(mapStateToProps, {SetStatusTalentos})(HomeAluno);



// WEBPACK FOOTER //
// ./src/components/aluno/home/home_aluno.js